function timeAgoCalculator(dateTime) {
  const todayDateTime = new Date();
  const agoDateTime = new Date(dateTime);
  const diffTime = Math.abs(todayDateTime.getTime() - agoDateTime.getTime());
  
  let result = "";
  switch (true) {
    case diffTime < 60 * 1000: {
      result = `${diffTime} second ago`;
      break;
    }
    case diffTime > 60 * 1000 && diffTime < 3600 * 1000: {
      const calcMin = Math.floor(diffTime / (60 * 1000));
      result = `${calcMin} minutes ago`;
      break;
    }
    case diffTime > 3600 * 1000 && diffTime < 86400 * 1000: {
      const calcHour = Math.floor(diffTime / (3600 * 1000));
      result = `${calcHour} hours ago`;
      break;
    }
    case diffTime > 86400 * 1000: {
      const calcDays = Math.floor(diffTime / (86400* 1000));
      result = `${calcDays} days ago`;
      break;
    }
    default:
      result = "Just now";
  }

  return result;
}

export default timeAgoCalculator;
